<div class="dropdown" [ngClass]="{'show': dropdownOpen}">
    <button class="btn btn-primary btn-icon btn-full btn-dropdown dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            (click)="toggleDropdown()"
            aria-haspopup="true"
            aria-expanded="false">
      <span class="rounded-icon" aria-hidden="true">
        <svg class="icon icon-primary">
          <use xlink:href="assets/icons/sprites.svg#it-user"></use>
        </svg>
      </span>
      <span class="d-none d-lg-block">{{ fullName }}</span>
      <svg class="icon-expand icon icon-sm icon-primary">
        <use href="assets/icons/sprites.svg#it-expand"></use>
      </svg>
    </button>

    <div class="dropdown-menu m" [ngClass]="{'show': dropdownOpen}" aria-labelledby="dropdownMenuButton">
      <div class="link-list-wrapper">
        <ul class="link-list">
          <li><a class="dropdown-item list-item" href="https://www.comune.rapallo.ge.it/area_eflow_personale/pagsistema.html">
            <span class="text-primary">Area Personale</span></a></li>
          <li><a class="dropdown-item list-item" (click)="signOut()">
            <span class="text-primary">Disconnetti</span></a></li>
        </ul>
      </div>
    </div>
</div>
